
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { VagaUnidade } from "app/pages/full-pages/vaga/vaga-unidade/vaga-unidade.model";
import { Observable } from "rxjs";

export abstract class AbVagaUnidade extends AppService {
  abstract getVagaUnidade();
  abstract getAllVagaUnidade(filter: AppFilter): Observable<any>;
  abstract saveVagaUnidade(vagaUnidade: VagaUnidade): Observable<any>;
  abstract deletar(id: number);
  abstract getVagasByUnidade(filter: AppFilter): Observable<any>;

}